import React from 'react';
import RPreview from "./RPreview";
import {useSelector} from "react-redux";


export default function Recommended(props) {

    const {
        watchOffCanvasIsActive,
        readOffCanvasIsActive,
        learnOffCanvasIsActive,
        faveWatchOffCanvasIsActive,
        faveReadOffCanvasIsActive,
        faveLearnOffCanvasIsActive
    } = useSelector((state) => state.navBar)

    return (
        <div className={` 
            Recommended bg-purple-dashboard pt-8 pr-6 hidden col-start-1 row-start-9 row-end-12 lg:col-start-8 col-end-25 pl-6 
            xl:row-start-3 xl:row-end-13 xl:col-start-20 xl:col-end-25 3xl:col-start-20
        ${ (
            watchOffCanvasIsActive ||
            readOffCanvasIsActive ||
            learnOffCanvasIsActive ||
            faveWatchOffCanvasIsActive ||
            faveReadOffCanvasIsActive ||
            faveLearnOffCanvasIsActive         
        ) ? "xl:block " : "sm:block"}
    `}>
            <RPreview />

        </div>
    );
}